<template>
  <nav
    v-if="data.length"
    class="page-filter page-filter__up"
    :class="{'page-filter--list': list, 'custom-scrollbar': !isTouch, 'page-filter--without-container': withoutContainer}"
  >
    <ul class="page-filter__list" v-if="isMobile">
      <li
        @click="handleClick(item)"
        v-for="item in computedFilters"
        :key="item.id"
        class="page-filter__item"
        :class="{'active': activeId === item.id}"
      >
        <span>{{ item.name }}</span>
      </li>
    </ul>
    <ul class="page-filter__list" v-else>
      <div class="page-filter__navigation">
        <div :class="`swiper-button-prev page-filter__navigation-prev page-filter__navigation-prev-${computedFilters.length}-${computedFilters[computedFilters.length - 1].id}`" slot="button-prev"></div>
        <div :class="`swiper-button-next page-filter__navigation-next page-filter__navigation-next-${computedFilters.length}-${computedFilters[computedFilters.length - 1].id}`" slot="button-next"></div>
      </div>
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="swiper-item" v-for="item in computedFilters" :key="item.id">
          <li
            @click="handleClick(item)"
            class="page-filter__item"
            :class="{'active': activeId === item.id}"
          >
            <span>{{ item.name }}</span>
          </li>
        </swiper-slide>
      </swiper>
    </ul>
  </nav>
</template>

<script>
import { isTouch } from '@/mixins/isTouchDevice'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'CategoryFilter',
  components: { SwiperSlide, Swiper },
  mixins: [isTouch],
  data () {
    return {
      activeId: null,
      windowWidth: window.innerWidth
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    list: {
      type: Boolean,
      default: false
    },
    withoutContainer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth <= 1024
    },
    swiperOption () {
      return {
        watchSlidesVisibility: true,
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        navigation: {
          nextEl: `.page-filter__navigation-next-${this.computedFilters.length}-${this.computedFilters[this.computedFilters.length - 1].id}`,
          prevEl: `.page-filter__navigation-prev-${this.computedFilters.length}-${this.computedFilters[this.computedFilters.length - 1].id}`
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        breakpoints: {
          1024: {
            slidesPerGroup: 4
          }
        }
      }
    },
    computedFilters () {
      if (this.data.length && !this.list) {
        return [ { name: this.$t('category_filter_all_products'), id: null }, ...this.data ]
      }

      if (this.data.length) return this.data

      return []
    }
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    handleClick (item) {
      this.activeId = item.id

      const emitData = {
        id: +item.id,
        link: item.link
      }

      this.$emit('change-filter', emitData)
    }
  },
  mounted () {
    if (this.data.length && this.list) this.handleClick(this.data[0])
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="sass">
.page-filter__list
  .swiper-container
    width: 100%
.page-filter__navigation
  .swiper-button-prev
    &:before
      content: ''
      position: absolute
      left: -1px
      z-index: -1
      top: 50%
      transform: translateY(-50%) rotate(180deg)
      width: 90px
      height: 40px
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)
      pointer-events: none
      +mmax($tablet)
        width: 45px
    &:after
      width: 30px
      height: 30px
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      border-radius: 50%
      display: flex
      align-items: center
      justify-content: center
      border: 1px solid #E7E7E7
      background-color: #e8e8e8
  .swiper-button-next
    &:before
      content: ''
      position: absolute
      right: -1px
      z-index: -1
      top: 50%
      transform: translateY(-50%)
      width: 90px
      height: 40px
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)
      pointer-events: none
      +mmax($tablet)
        width: 45px
    &:after
      width: 30px
      height: 30px
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      border-radius: 50%
      display: flex
      align-items: center
      justify-content: center
      border: 1px solid #E7E7E7
      background-color: #e8e8e8
  .swiper-button-prev, .swiper-button-next
    pointer-events: all
    margin-top: 0
    transform: translateY(-50%)
    border-radius: 50% !important
    background-color: #F8F8F8 !important
    //&:hover, &:focus
    //  border-color: #E7E7E7 !important
  .swiper-button-disabled
    pointer-events: none !important
    opacity: 0 !important
    &:before
      opacity: 0
.page-filter .swiper-slide
  width: auto
.page-filter .swiper-wrapper
  padding: 3px 0
</style>
<style scoped lang="sass">
@import "../../../../node_modules/swiper/css/swiper.min.css"

@import "../../../styles/swiper/swiper"

.page-filter
  overflow: auto

.page-filter__navigation
  position: absolute
  left: 0
  top: 50%
  width: 100%
  transform: translateY(-50%)
  z-index: 3
  pointer-events: none
.page-filter__list
  flex-flow: row nowrap
  position: relative

  +mmin($tablet)
    flex-flow: row wrap

.page-filter__item
  cursor: pointer
  font-size: 14px
  margin-bottom: 20px
  flex-shrink: 0
  display: inline-block
  +mmin($tablet--hor)
    margin-bottom: 0
.page-filter--without-container
  padding: 0 15px
  margin: 0 -15px

  +mmin($tablet)
    padding: 0
    margin: 0

.page-filter--list
  margin: 0 0 20px

  +mmin($tablet--hor)
    width: 25%
    margin: 0

  .page-filter__list
    display: flex
    padding: 0 15px
    flex-flow: row nowrap

    +mmin($tablet--hor)
      flex-flow: column
      padding: 25px 20px
      border-top: 1px solid #f3f3f3

  .page-filter__item

    span
      +mmin($tablet--hor)
        padding: 0

    &:hover
      border-color: $main-color

    +mmin($tablet--hor)
      flex-shrink: 0
      padding: 11px 20px
      text-align: left
      margin: 0 0 -1px
      border-color: transparent

.active
  pointer-events: none
  border-color: $main-color
</style>
